// export const BASE_URL = 'http://sachcbservicealb-645337283.ap-south-1.elb.amazonaws.com/api';

// export const BASE_URL = "https://api.sach.org.in/api";
export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL; //"https://dev-chatapi.sach.org.in/v1";
export const BASE_URL = process.env.REACT_APP_BASE_URL; //"https://dev-aggregatorapi.sach.org.in/api";
export const BASE_IMAGE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
//"https://sach-user-profile-blob.s3.ap-south-1.amazonaws.com/";
export const SANDBOX_URL = process.env.REACT_APP_SANDBOX_URL;
export const SHARED_BASE_URL = process.env.REACT_APP_SHARED_BASE_URL;
//"https://sdk.cashfree.com/js/ui/2.0.0/cashfree.sandbox.js";
export const LOGIN_URL = `${BASE_URL}/login`;

export const GET_SIGNUP_TEMPLATE = `${BASE_URL}/signupTemplate`;

export const GENERATE_OTP_URL = `${BASE_URL}/generateOtp`;
export const VALIDATE_OTP_URL = `${BASE_URL}/validateOtp`;
export const SUBMIT_BASIC_INFO_URL = `${BASE_URL}/user/submitBasicInfo`;

/***************** User Section  *********************/

// events
export const FETCH_EVENTS_URL = `${BASE_URL}/getEventUI`;
export const SEARCH_EVENTS_URL = `${BASE_URL}/getEventUISearch`;
export const FETCH_EACH_EVENT_URL = `${BASE_URL}/getEventInfo`;
export const REGISTER_EVENT_URL = `${BASE_URL}/registerEvent`;

// blogs
export const FETCH_BLOGS_URL = `${BASE_URL}/getBlogUI`;
export const SEARCH_BLOGS_URL = `${BASE_URL}/getBlogUISearch`;

// my blogs
export const USER_GET_BLOG_DETAIL_URL = `${BASE_URL}/getBlogById`;
export const USER_GET_RELATED_BLOG_URL = `${BASE_URL}/getRelatedBlogById`;
export const USER_GET_BLOG_DATA_URL = `${BASE_URL}/getBlogUser`;
export const USER_PUBLISH_BLOG_URL = `${BASE_URL}/createBlog`;
export const USER_GET_BLOG_TABLE_CONTENT_URL = `${BASE_URL}/getTableContentUser`;
export const USER_MODIFY_BLOG_URL = `${BASE_URL}/modifyBlogUser`;
export const USER_GET_BLOG_COUNT_URL = `${BASE_URL}/getBlogCountUser`;

// my/all testimonial
export const USER_GET_TESTIMONIAL_URL = `${BASE_URL}/getTestUser`;
export const GET_ALL_TESTIMONIAL_URL = `${BASE_URL}/getUserTestUI`;
export const USER_MODIFY_TESTIMONIAL_URL = `${BASE_URL}/createTest`;
/***************** Admin Section  *********************/

//common
export const ADMIN_UPLOAD_FILE_URL = `${BASE_URL}/upload`;
export const GET_ADMIN_INFO = `${BASE_URL}/getAdminInfo`;

//dashboard
export const ADMIN_GET_USER_COUNT_URL = `${BASE_URL}/userCount`;
export const USER_GET_DASHBOARD_DATA = `${BASE_URL}/dashboardData`;
export const USER_GET_HEADER_DATA = `${BASE_URL}/headerData`;
export const USER_GET_FOOTER_DATA = `${BASE_URL}/footerData`;
export const USER_GET_ABOUTUS_DATA = `${BASE_URL}/aboutUsData`;
export const USER_GET_FOUNDATION_DATA = `${BASE_URL}/foundationData`;
export const USER_GET_COUNSELING_DATA = `${BASE_URL}/counselingData`;
export const USER_GET_SECTORAL_DATA = `${BASE_URL}/sectorialData`;

// user management
export const ADMIN_GET_USERS_URL = `${BASE_URL}/getUser`;
export const ADMIN_GET_VIEW_DETAIL_URL = `${BASE_URL}/getUserById`;
export const ADMIN_INVITE_USER_URL = `${BASE_URL}/user/invite`;
export const MODIFY_USER_URL = `${BASE_URL}/modifyUser`;
export const CHANGE_USER_PASSWORD_URL = `${BASE_URL}/users/changePassword`;

// userrole management
export const ADMIN_GET_USER_ROLE_COUNT_URL = `${BASE_URL}/userCountWithRole`;
export const ADMIN_GET_USER_ROLE_URL = `${BASE_URL}/getUserWithRole`;
export const ADMIN_GET_ROLE_URL = `${BASE_URL}/getRoles`;
export const ADMIN_CREATE_ROLE_URL = `${BASE_URL}/createRole`;
export const ADMIN_GET_PERM_USER_URL = `${BASE_URL}/getPermUserWithRole`;
export const ADMIN_APPLY_PERM_USER_URL = `${BASE_URL}/applyPermUserWithRole`;

// event management
export const ADMIN_GET_EVENT_COUNT_URL = `${BASE_URL}/getEventCount`;
export const ADMIN_GET_EVENT_URL = `${BASE_URL}/getEventByUserId`;
export const ADMIN_CREATE_EVENT_URL = `${BASE_URL}/createEvent`;
export const ADMIN_GET_EVENT_BY_ID_URL = `${BASE_URL}/getEventById`;
export const ADMIN_MODIFY_EVENT_URL = `${BASE_URL}/ModifyEvent`;
export const ADMIN_GENERATE_EVENT_URL = `${BASE_URL}/generateLinkEvent`;

// category management
export const USER_GET_ARTICLE_DATA_URL = `${BASE_URL}/getBlog?article=y`;
export const ADMIN_GET_CATEGORY_URL = `${BASE_URL}/getCategory`;
export const ADMIN_GET_CATEGORY_COUNT_URL = `${BASE_URL}/getVideoCount`;
export const ADMIN_CREATE_EDIT_CATEGORY_URL = `${BASE_URL}/createCategory`;
export const ADMIN_GET_CATEGORY_VIDEO_URL = `${BASE_URL}/getVideo`;
export const ADMIN_DELETE_VIDEO_URL = `${BASE_URL}/modifyVideo`;
export const ADMIN_UPLOAD_VIDEO_URL = `${BASE_URL}/createVideo`;
export const ADMIN_CATEGORY_NAME_FILE_URL = `${BASE_URL}/upload`;

export const USER_GET_CATEGORY_VIDEO_URL = `${BASE_URL}/getVideoUI`;
export const USER_GET_CATEGORY_VIDEO_BY_ID_URL = `${BASE_URL}/getVideoById`;
export const USER_GET_CATEGORY_All_DATA = `${BASE_URL}/getVideoUISearch`;

export const USER_GET_CATEGORY_VIDEO_COMMENTS = `${BASE_URL}/getVideolikeComments`;
export const USER_POST_CATEGORY_VIDEO_COMMENTS = `${BASE_URL}/likeVideo`;
export const USER_POST_CATEGORY_COMMENTS_REPLY = `${BASE_URL}/comment`;
// testimonial management
export const ADMIN_GET_TESTIMONIAL_URL = `${BASE_URL}/getTest`;
export const ADMIN_GET_TESTIMONIAL_COUNT_URL = `${BASE_URL}/getTestCount`;
export const ADMIN_MODIFY_TESTIMONIAL_URL = `${BASE_URL}/modifyTest`;
export const ADMIN_CREATE_TESTIMONIAL_URL = `${BASE_URL}/createTest`;

// blog management
export const ADMIN_GET_BLOG_DETAIL_URL = `${BASE_URL}/getBlogById`;
export const ADMIN_GET_BLOG_DATA_URL = `${BASE_URL}/getBlog`;
export const ADMIN_PUBLISH_BLOG_URL = `${BASE_URL}/createBlog`;
export const ADMIN_GET_BLOG_TABLE_CONTENT_URL = `${BASE_URL}/getTableContent`;
export const ADMIN_MODIFY_BLOG_URL = `${BASE_URL}/modifyBlog`;
export const ADMIN_GET_BLOG_COUNT_URL = `${BASE_URL}/getBlogCount`;

export const POST_CONTACT_US = `${BASE_URL}/contact-us`;
export const POST_CONTRIBUTE = `${BASE_URL}/volInterns`;

export const ADVISE_TOPIC_REQUEST = `${BASE_URL}/requestForAdviseAndTopicRequest`;
// privacy policy
export const PRIVACY_POLICY = `${BASE_URL}/getPrivacyPolicy`;
// terms & conditions
export const TERMS_CONDITIONS = `${BASE_URL}/getTermsConditions`;

// FAQ
export const FAQ = `${BASE_URL}/freqAskQuesAll`;
// forgot Password
export const FORGOT_PASSWORD = `${BASE_URL}/forgetPasswd`;

//contact Data
export const CONTACT_DATA_MULTI = `${BASE_URL}/contactData`;

// grant Api Data
export const GRANT_DATA_MULTI = `${BASE_URL}/grantData`;
// Farming
export const FARMING_DATA_MULTI = `${BASE_URL}/farmingData`;
// Cookies Data
export const COOKIES_DATA_MULTI = `${BASE_URL}/cookiesData`;
// Contribute Data
export const CONTRIBUTE_DATA_MULTI = `${BASE_URL}/contributeData`;
// login and signup Data
export const LOGIN_SIGNUP_DATA_MULTI = `${BASE_URL}/signupData`;
// profile Data
export const PROFILE_DATA_MULTI = `${BASE_URL}/profileData`;
// Subscription
export const POST_SUBSCRIPTION_USER_URL = `${BASE_URL}/registerSubscribeUser`;
// Resource api data
export const GET_RESOURCE_DATA_URL = `${BASE_URL}/getAddResourceFeatureDataAll`;

//Contribution API's

export const POST_CONTRIBUTE_CREATE_PAYMENT = `${BASE_URL}/createContribute`;
export const POST_CONTRIBUTE_CHECK_PAYMENT = `${BASE_URL}/updateContribute`;
export const GET_CONTRIBUTE_DATA = `${BASE_URL}/getContribute`;
export const GET_CONTRIBUTE_COUNT = `${BASE_URL}/getContributeCount`;
export const GET_COUNTRIES = `${BASE_URL}/getCountry`;
export const GET_STATES = `${BASE_URL}/getState`;
export const GET_CITIES = `${BASE_URL}/getCity`;
export const GET_PIN = `${BASE_URL}/getStateCityByPin`;

// Meta tag
export const USER_META_DATA_URL = `${BASE_URL}/getMetaDataAll`;
// Weekly thought
export const USER_WEEKLY_THOUGHT_URL = `${BASE_URL}/todayWeekSubVidMod`;

// change Mobile Number

export const USER_CHANGE_MOBILE_URL = `${BASE_URL}/users/changeNumber`;
export const USER_VERIFY_MOBILE_URL = `${BASE_URL}/validate/changeNumber`;

// user write blogs
export const USER_WRITE_GET_API = `${BASE_URL}/writeBlogData`;

//Ask question
export const CATEGORIES_GET_API = `${BASE_URL}/qaGetCategories`;
export const SUBCATEGORIES_BY_CATEGORY = `${BASE_URL}/qaGetSubcategoriesByCategory`;
export const USER_QUESTIONS_GET_API = `${BASE_URL}/qaGetUserThreads`;
export const GET_QUESTION_BY_ID = `${BASE_URL}/qaGetQuesThreads`;
export const CREATE_QUESTION = `${BASE_URL}/qaQuestion`;
export const CREATE_NEW_QUESTION = `${BASE_URL}/qaNewQuestion`;
export const DELETE_USER_QUESTIONS = `${BASE_URL}/qaDelQuestion`;
